export var pluralize = function (quantity, singular, plural) { return "".concat(quantity, " ").concat(parseInt(String(quantity)) === 1 ? singular : plural); };
